export const VERTICAL_MARGIN = 32;
export const HORIZONTAL_MARGIN = 16;
export const AXIS_LABEL_PADDING = 48;
